const CarmenHomePage = ({ isCarmenLicense }) => {
    if (!isCarmenLicense) {
        return null
    }
    return (<div className="row mt-3 ms-5 me-5 mb-3">
        <div className="col d-flex flex-column">
            <div className="d-flex justify-content-center align-items-center mb-2">
                <h3>Carmen Polska Sp. z.o.o życzymy udanych zakupów</h3>
            </div>
            <span>Zgodnie z dyrektywą unijną 2014/40/UE i rozporządzeniem 218/574 od dnia 20.05.2019 weszły w życie przepisy dotyczące identyfikacji wyrobów tytoniowych w UE.</span>
            <span className="mt-2">W związku z powyższym jesteśmy zmuszeni do podjęcia niezbędnych działań w obszarze informatycznym, logistycznym i organizacji czasu pracy aby dostosować się do nowych przepisów.
                Jednocześnie chcemy zachować najwyższy poziom obsługi aby nasi klienci jak najmniej odczuli wejście w życie nowych regulacji prawnych.</span>

            <span className="mt-2">Od dnia 20.05.2019 wprowadzamy następujące zmiany:</span>
            <ul>
                <li>zamówienia i sprzedaż papierosów będzie prowadzona tylko w pełnych pakietach</li>
                <li>zamówienia z planowaną dostawą na poniedziałek należy składać w piątek do godziny 15:00 lub w sobotę do godziny 12:00</li>
            </ul>

            <span className="mt-2">Dziękujemy za wyrozumiałość i zachęcamy do składania zamówień za pośrednictwem strony eHandlu</span>
            <span className="mt-2">Z naszego serwisu skorzystało już ponad 8750 osób. Bądź jednym z nas.</span>
            <span className="mt-2">Zapraszamy!</span>
        </div>
    </div>)
}

export default CarmenHomePage